import { PaymentStatementStatus } from '../enum/payment-statement-status.enum';

export class PaymentStatement {

	id: number;

	establishmentId: number;

	//data do fechamento
	date: number;

	// data que se refere a qual data é este fechamento
	dateReference: number;

	// valor total pagos pelo app
	totalPaidByApp: number;

	// taxa serviço Fastget
	totalFastgetFeeByApp: number;

	// taxa pagamento
	totalPaymentFee: number;

	// valor parceiro tem a receber
	totalToReceive: number;

	// valor total de pedidos pagos para o Parceiro
	totalPaidToPartner: number;

	// taxas serviço Fastget
	totalFastgetFeeByPartner: number;

	// saldo devedor fechamento anterior
	previousBalance: number;

	// total parceiro tem a pagar
	totalToPay: number;

	// total (saldo) de total a receber - total a pagar
	balance: number;
	status: PaymentStatementStatus;
	firstClosingMonth: boolean;

	// url para boleto bancário
	bankSlipUrl: string;

	// data de vencimento do boleto
	bankSlipDueDate: number;

	//auxilia a montar a tela, para o zone do Angular não ficar toda hora realizando uma lógica desnecessária
	description: string;

	// Percentual fastget
	fastgetFee: number;
	// taxa do cartão iugu
	paymentFee: number;

	constructor(obj: any = { }) {
		Object.assign(this, obj);
	}
}

export interface PaymentStatementsResponse {
	count: number;
	closingModels: Array<PaymentStatement>;
}



// WEBPACK FOOTER //
// ./src/app/pages/account/models/payment-statement.model.ts